(() => {
  
  function initMerchCollection(root){
    if (!root || !window.fetch || !window.URL || !window.history) return;

    const sectionId = root.getAttribute('data-section-id') || '';
    const rootId = root.id || '';
    const getVarNum = (name, fallback) => {
      try{
        const v = getComputedStyle(root).getPropertyValue(name).trim();
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : fallback;
      }catch(e){ return fallback; }
    };

    const MIN_LOADER_MS = getVarNum('--mc-loader-min-ms', 180);
    let busySince = 0;

        // --- Stable loader baseline height (prevents Y "jump" when results count changes) ---
    let prevInlineMinHeight = '';
    let baselineHeight = 0;

    // tenta reaproveitar baseline anterior guardado no store (entre reloads AJAX)
    try{
      const store = (window.__MerchCollection = window.__MerchCollection || {});
      if (store[sectionId] && Number.isFinite(store[sectionId].baselineHeight)) {
        baselineHeight = store[sectionId].baselineHeight;
      }
    }catch(e){}

    const measureHeight = () => {
      try { return Math.ceil(root.getBoundingClientRect().height); } catch(e){ return 0; }
    };

    const lockSectionHeight = (persist = true) => {
      try{
        const h = measureHeight();

        // baseline = height actual medida, nunca acima de 1.3× o viewport
        const maxAllowed = Math.round(window.innerHeight * 1.3);
        baselineHeight = Math.min(Math.max(baselineHeight || 0, h || 0), maxAllowed);

        prevInlineMinHeight = root.style.minHeight || '';
        if (baselineHeight > 0) root.style.minHeight = `${baselineHeight}px`;

        // Só persiste no store quando pedido (boot/reveal phase).
        // Durante 'load' não persistimos para não contaminar o próximo init.
        if (persist){
          try{
            const store = (window.__MerchCollection = window.__MerchCollection || {});
            store[sectionId] = store[sectionId] || {};
            store[sectionId].baselineHeight = baselineHeight;
          }catch(e){}
        }
      }catch(e){}
    };

    const unlockSectionHeight = () => {
      try{
        root.style.minHeight = prevInlineMinHeight || '';
        prevInlineMinHeight = '';
      }catch(e){}
    };




    const store = (window.__MerchCollection = window.__MerchCollection || {});
    if (store[sectionId] && typeof store[sectionId].cleanup === 'function') {
      try { store[sectionId].cleanup(); } catch(e) {}
    }

    const offFns = [];
    const on = (el, ev, fn, opts) => {
      if (!el) return;
      el.addEventListener(ev, fn, opts || false);
      offFns.push(() => { try { el.removeEventListener(ev, fn, opts || false); } catch(e){} });
    };

    const qs = (sel, ctx) => (ctx || root).querySelector(sel);
    const qsa = (sel, ctx) => Array.prototype.slice.call((ctx || root).querySelectorAll(sel));

    const nextFrames = (n=2) => new Promise(resolve => {
      const step = () => (n-- <= 0 ? resolve() : requestAnimationFrame(step));
      requestAnimationFrame(step);
    });

    const ensureMinLoaderTime = () => {
      const elapsed = Date.now() - (busySince || 0);
      const wait = Math.max(0, MIN_LOADER_MS - elapsed);
      return new Promise(r => setTimeout(r, wait));
    };

    const setBusy = (mode) => {
    try{
      if (mode === 'boot' || mode === 'load') busySince = Date.now();

      // 'load': conteúdo existente fica visível (opacity 0.35), layout não muda — sem lockHeight.
      // 'boot': novo conteúdo está escondido (opacity 0), precisa de lock para evitar jump.
      // no filter reload, the layout is already stable — no need to lock height
      if (mode === 'boot' && !root.classList.contains('is-filter-reload')) lockSectionHeight(true);

      root.classList.toggle('is-booting', mode === 'boot');
      root.classList.toggle('is-loading', mode === 'load');
      root.classList.remove('is-revealing');
      root.classList.remove('is-ready');

      void root.offsetHeight;
    }catch(e){}
  };


    const fontsReady = () => {
      try{
        if (document.fonts && document.fonts.ready) return document.fonts.ready.catch(() => {});
      }catch(e){}
      return Promise.resolve();
    };

    // --- Judge.me: render + hydrate count from injected DOM ---
    const mcHydrateJudgeMe = (container) => {
      try{
        container = container || root;

        // força o JM a renderizar badges quando o HTML muda (AJAX)
        if (window.jdgm && typeof window.jdgm.renderBadges === "function") {
          window.jdgm.renderBadges(container);
        }

        requestAnimationFrame(() => {
          try{
            container.querySelectorAll("[data-jm-wrap]").forEach((wrap) => {
              const badge = wrap.querySelector(".jdgm-prev-badge");
              if (!badge) return;

              const n = parseInt(badge.getAttribute("data-number-of-reviews") || "0", 10);

              const countEl = wrap.querySelector("[data-jm-count]");
              const emptyEl = wrap.querySelector("[data-jm-empty]");

              if (n > 0) {
                if (countEl) {
                  countEl.textContent = `(${n})`;
                  countEl.hidden = false;
                }
                if (emptyEl) emptyEl.hidden = true;
              } else {
                if (countEl) countEl.hidden = true;
                if (emptyEl) emptyEl.hidden = false;
              }
            });
          }catch(e){}
        });
      }catch(e){}
    };


    const judgeMeReady = (container) => {
      container = container || root;
      const hasBadge = !!container.querySelector('.jdgm-widget, .jdgm-prev-badge, [class*="jdgm-"]');
      if (!hasBadge) return Promise.resolve();

      return new Promise(resolve => {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          clearTimeout(t);
          try{ obs && obs.disconnect(); }catch(e){}
          resolve();
        };

        const t = setTimeout(finish, 500);

        let obs;
        try{
          obs = new MutationObserver(() => {
            const ok =
              container.querySelector('.jdgm-prev-badge__stars, .jdgm-star, .jdgm-prev-badge') ||
              container.querySelector('[class*="jdgm-"] svg');
            if (ok) finish();
          });
          obs.observe(container, { childList:true, subtree:true });
        }catch(e){}

        const immediateOk =
          container.querySelector('.jdgm-prev-badge__stars, .jdgm-star, .jdgm-prev-badge') ||
          container.querySelector('[class*="jdgm-"] svg');
        if (immediateOk) finish();
      });
    };

    
    const waitStableLayout = (container, stableMs = 260, maxMs = 2200) => {
      container = container || root;
      return new Promise((resolve) => {
        let done = false;
        let lastChange = Date.now();
        const finish = () => {
          if (done) return;
          done = true;
          try{ ro && ro.disconnect(); }catch(e){}
          resolve();
        };

        const deadline = setTimeout(finish, maxMs);

        let ro;
        if (window.ResizeObserver){
          try{
            ro = new ResizeObserver(() => { lastChange = Date.now(); });
            ro.observe(container);
          }catch(e){}
        }

        const tick = () => {
          if (done) return;
          if ((Date.now() - lastChange) >= stableMs) {
            clearTimeout(deadline);
            finish();
            return;
          }
          setTimeout(tick, 40);
        };
        tick();
      });
    };
const revealWhenReady = async (container) => {
      container = container || root;
      const isFilterReload = container.classList.contains('is-filter-reload');

      // garante que o estado "hidden" foi pintado antes de fazer reveal
      await nextFrames(2);

      await fontsReady();
      await judgeMeReady(container);
      await waitStableLayout(container.querySelector('[data-mc-stage]') || container, 80, 800);

      await ensureMinLoaderTime();

      // 2 frames extra antes de remover classes => transition dispara sempre
      await nextFrames(2);

      try{
        // 1) congela a posição do spinner ANTES de remover classes
        //    → o transform calculado (-350px) fica como inline style
        //    → quando as classes são removidas, o spinner não "salta" de posição
        try{
          const bootEl = container.querySelector('[data-mc-boot]');
          if (bootEl) {
            const t = window.getComputedStyle(bootEl).transform;
            if (t && t !== 'none' && t !== 'matrix(1, 0, 0, 1, 0, 0)')
              bootEl.style.transform = t;
          }
        }catch(e){}

        // 2) remove classes busy → dispara fade-out do spinner (300ms CSS transition)
        container.classList.remove('is-booting');
        container.classList.remove('is-loading');

        // 3) espera o spinner fazer fade-out; depois limpa o inline transform
        await new Promise(r => setTimeout(r, 300));
        try{
          const bootEl = container.querySelector('[data-mc-boot]');
          if (bootEl) bootEl.style.removeProperty('transform');
        }catch(e){}

        // 4) garante que o opacity:0 do conteúdo está commitado
        try{ void container.offsetHeight; }catch(e){}

        // 5) adiciona is-ready no frame seguinte => transition dispara limpo
        requestAnimationFrame(() => {
          try{ container.classList.add('is-ready'); }catch(e){}
          // limpa o flag de filter-reload
          try{ container.classList.remove('is-filter-reload'); }catch(e){}
          // atualiza badge de filtros ativos no botão mobile
          try{
            const countEl = document.querySelector('[data-mc-active-count]');
            if (countEl) {
              const n = qsa('.mc__chip', container).length;
              countEl.textContent = n || '';
              countEl.style.display = n ? '' : 'none';
            }
          }catch(e){}

          // solta a altura só no boot inicial (filter reload nunca bloqueou)
          if (!isFilterReload) {
            const ms = getVarNum('--mc-reveal-ms', 250);
            setTimeout(() => {
              try{ unlockSectionHeight(); }catch(e){}
            }, Math.max(0, ms) + 50);
          }
        });

      }catch(e){}

    };

    // drawer (mobile)
    const lockBody = (lock) => {
      try{
        document.body.style.overflow = lock ? 'hidden' : '';
        document.body.style.touchAction = lock ? 'none' : '';
      }catch(e){}
    };

    const isFiltersOpen = () => {
      const sidebar = qs('[data-mc-sidebar]');
      return !!(sidebar && sidebar.classList.contains('is-open'));
    };


    // --- Portal (move overlay + sidebar para <body> para ficar acima de header/sections) ---
    let portal = {
      active: false,
      sidebarParent: null,
      overlayParent: null,
      sidebarPlaceholder: null,
      overlayPlaceholder: null
    };

    // --- copy CSS vars (--mc-*) from section root to a moved node (portal) ---
    const copyMcVars = (targetEl) => {
      try{
        if (!targetEl) return;
        const cs = getComputedStyle(root);
        for (let i = 0; i < cs.length; i++){
          const prop = cs[i];
          if (prop && prop.startsWith('--mc-')){
            targetEl.style.setProperty(prop, cs.getPropertyValue(prop));
          }
        }
      }catch(e){}
    };


    const portalMount = () => {
      const sidebar = qs('[data-mc-sidebar]');
      const overlay = qs('[data-mc-overlay]');
      if (!sidebar || !overlay) return;

      if (portal.active) return;

      // placeholders para voltar ao sítio certo
      portal.sidebarParent = sidebar.parentNode;
      portal.overlayParent = overlay.parentNode;

      portal.sidebarPlaceholder = document.createComment('mc-sidebar-placeholder');
      portal.overlayPlaceholder = document.createComment('mc-overlay-placeholder');

      portal.sidebarParent.insertBefore(portal.sidebarPlaceholder, sidebar);
      portal.overlayParent.insertBefore(portal.overlayPlaceholder, overlay);

      // move para body
      document.body.appendChild(overlay);
      document.body.appendChild(sidebar);

      copyMcVars(overlay);
      copyMcVars(sidebar);

      // classes de portal (CSS do patch)
      overlay.classList.add('mc__portal-overlay');
      sidebar.classList.add('mc__portal-sidebar');

      portal.active = true;
    };

    const portalUnmount = () => {
      const sidebar = qs('[data-mc-sidebar]') || document.querySelector('.mc__portal-sidebar');
      const overlay = qs('[data-mc-overlay]') || document.querySelector('.mc__portal-overlay');
      if (!portal.active) return;

      try{
        if (overlay && portal.overlayPlaceholder && portal.overlayParent){
          portal.overlayParent.insertBefore(overlay, portal.overlayPlaceholder);
          portal.overlayPlaceholder.remove();
        }
        if (sidebar && portal.sidebarPlaceholder && portal.sidebarParent){
          portal.sidebarParent.insertBefore(sidebar, portal.sidebarPlaceholder);
          portal.sidebarPlaceholder.remove();
        }
      }catch(e){}

      try{
        overlay && overlay.classList.remove('mc__portal-overlay','is-show');
        sidebar && sidebar.classList.remove('mc__portal-sidebar');
      }catch(e){}

      portal = { active:false, sidebarParent:null, overlayParent:null, sidebarPlaceholder:null, overlayPlaceholder:null };
    };


    const openFilters = () => {
      // Reset defensivo: se portal ficou marcado como active mas o elemento já não está no body
      if (portal.active && !document.querySelector('.mc__portal-sidebar')) {
        portal = { active: false, sidebarParent: null, overlayParent: null, sidebarPlaceholder: null, overlayPlaceholder: null };
      }

      const sidebar = qs('[data-mc-sidebar]');
      const overlay = qs('[data-mc-overlay]');
      const btn = qs('[data-mc-filters-open]');
      if (!sidebar || !overlay) return;

      // Já está aberto — não fazer nada
      if (sidebar.classList.contains('is-open') || document.querySelector('.mc__portal-sidebar.is-open')) return;

      portalMount();

      // reset estado drag
      sidebar.classList.remove('is-dragging');
      sidebar.style.removeProperty('--mc-sheet-drag');

      overlay.hidden = false;
      overlay.classList.add('is-show');
      overlay.style.display = 'block';

      sidebar.classList.add('is-open');

      if (btn) btn.setAttribute('aria-expanded', 'true');
      lockBody(true);
    };


    const closeFilters = (opts = {}) => {
      const sidebar = qs('[data-mc-sidebar]') || document.querySelector('.mc__portal-sidebar');
      const overlay = qs('[data-mc-overlay]') || document.querySelector('.mc__portal-overlay');
      const btn = qs('[data-mc-filters-open]');
      if (!sidebar || !overlay) return;

      // evita duplo close
      if (sidebar.classList.contains('is-closing')) return;

      const immediate = !!opts.immediate;

      // reset overlay opacity (caso estivesse a arrastar)
      overlay.style.opacity = '';

      if (immediate){
        sidebar.classList.remove('is-open', 'is-dragging', 'is-closing');
        sidebar.style.removeProperty('--mc-sheet-drag');

        overlay.hidden = true;
        overlay.classList.remove('is-show');
        overlay.style.display = 'none';

        if (btn) btn.setAttribute('aria-expanded', 'false');
        lockBody(false);
        portalUnmount();
        return;
      }

      // animação slide down
      sidebar.classList.add('is-closing');
      sidebar.classList.remove('is-open', 'is-dragging');
      sidebar.style.removeProperty('--mc-sheet-drag');

      // força ir para baixo (CSS base do sheet deve fazer translateY(110%))
      sidebar.style.transform = 'translate3d(0, 110%, 0)';

      const finish = () => {
        try{
          sidebar.classList.remove('is-closing');
          sidebar.style.transform = '';
          sidebar.style.removeProperty('--mc-sheet-drag');

          overlay.hidden = true;
          overlay.classList.remove('is-show');
          overlay.style.display = 'none';
          overlay.style.opacity = '';

          if (btn) btn.setAttribute('aria-expanded', 'false');
          lockBody(false);

          portalUnmount();
        }catch(e){}
      };

      const t = setTimeout(finish, 320);
      sidebar.addEventListener('transitionend', function onEnd(ev){
        if (ev.propertyName !== 'transform') return;
        sidebar.removeEventListener('transitionend', onEnd);
        clearTimeout(t);
        finish();
      });
    };

    const bindBottomSheetDrag = () => {
      const sidebar = qs('[data-mc-sidebar]') || document.querySelector('.mc__portal-sidebar');
      if (!sidebar) return;

      // evita listeners duplicados
      if (sidebar.__mcDragBound) return;
      sidebar.__mcDragBound = true;

      const header = sidebar.querySelector('.mc__sidebar-top') || sidebar;

      let startY = 0;
      let dragging = false;

      const CLOSE_PX = 140;      // distância para fechar
      const MAX_UP = 120;        // máximo rubberband para cima (px)
      const UP_RESIST = 0.35;    // resistência (quanto menor, mais “pesado”)

      let lastY = 0;
      let lastT = 0;
      let vy = 0;
      let downY = 0;             // só conta drag para baixo p/ fechar

      const canStartDrag = (e) => {
        if (!window.matchMedia || !matchMedia('(max-width: 1199px)').matches) return false;
        if (!sidebar.classList.contains('is-open')) return false;

        const t = e.target;
        // não começar drag em elementos interativos
        if (t && (t.closest('button') || t.closest('a') || t.closest('input') || t.closest('select'))) return false;

        return true;
      };

      const onDown = (e) => {
        if (!canStartDrag(e)) return;

        dragging = true;
        sidebar.classList.add('is-dragging');

        startY = (e.touches ? e.touches[0].clientY : e.clientY);
        lastY = startY;
        lastT = performance.now();
        vy = 0;
        downY = 0;

        sidebar.style.setProperty('--mc-sheet-drag', '0px');

        e.preventDefault();
      };

      const onMove = (e) => {
        if (!dragging) return;

        const y = (e.touches ? e.touches[0].clientY : e.clientY);
        const dyRaw = y - startY;

        // velocidade (px/ms)
        const now = performance.now();
        const dt = Math.max(1, now - lastT);
        vy = (y - lastY) / dt;
        lastY = y;
        lastT = now;

        let dragPx = dyRaw;

        // rubberband para cima (dyRaw negativo)
        if (dyRaw < 0) {
          const up = Math.min(MAX_UP, Math.abs(dyRaw));
          dragPx = -up * UP_RESIST;
        }

        // para fechar conta só o arrasto para baixo
        downY = Math.max(0, dyRaw);

        // aplica via CSS var (ganha ao transform !important do is-open)
        sidebar.style.setProperty('--mc-sheet-drag', `${dragPx}px`);

        // overlay fade só quando vai para baixo
        const overlay = document.querySelector('.mc__portal-overlay') || qs('[data-mc-overlay]');
        if (overlay) {
          if (downY > 0) {
            const a = 1 - Math.min(0.65, downY / 500);
            overlay.style.opacity = String(a);
          } else overlay.style.opacity = '';
        }

        e.preventDefault();
      };

      const onUp = () => {
        if (!dragging) return;
        dragging = false;

        sidebar.classList.remove('is-dragging');
        sidebar.style.removeProperty('--mc-sheet-drag');

        const overlay = document.querySelector('.mc__portal-overlay') || qs('[data-mc-overlay]');
        if (overlay) overlay.style.opacity = '';

        const velocityDown = vy > 0 ? (vy * 1000) : 0; // px/s aprox
        const shouldClose = (downY > CLOSE_PX) || (velocityDown > 900);

        if (shouldClose) closeFilters();
        else sidebar.classList.add('is-open');
      };

      // touch
      header.addEventListener('touchstart', onDown, { passive: false });
      header.addEventListener('touchmove', onMove, { passive: false });
      header.addEventListener('touchend', onUp, { passive: true });
      header.addEventListener('touchcancel', onUp, { passive: true });

      // pointer
      header.addEventListener('pointerdown', onDown, { passive: false });
      window.addEventListener('pointermove', onMove, { passive: false });
      window.addEventListener('pointerup', onUp, { passive: true });

      offFns.push(() => {
        try{ sidebar.__mcDragBound = false; }catch(e){}
        header.removeEventListener('touchstart', onDown);
        header.removeEventListener('touchmove', onMove);
        header.removeEventListener('touchend', onUp);
        header.removeEventListener('touchcancel', onUp);

        header.removeEventListener('pointerdown', onDown);
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
      });
    };


    const bindDrawer = () => {
      on(qs('[data-mc-filters-open]'), 'click', openFilters);

      // Event delegation — apanha X e mc__drawer-apply (e qualquer outro data-mc-filters-close)
      // Funciona antes e depois do portal (sidebar movida para body)
      on(document, 'click', (e) => {
        if (e.target.closest('[data-mc-filters-close]')) closeFilters();
      });

      // tap fora fecha com animação
      on(qs('[data-mc-overlay]'), 'click', () => closeFilters());

      on(document, 'keydown', (e) => { if (e.key === 'Escape') closeFilters(); });

      // liga drag 1x (tem guard __mcDragBound)
      bindBottomSheetDrag();

      const bindSwipeGestures = () => {
      let startX = 0, startY = 0, tracking = false;

      // tunáveis
      const EDGE_PX = 22;        // só abre se começar perto da margem esquerda
      const MIN_X = 60;          // distância mínima em X
      const MAX_Y = 40;          // tolerância vertical
      const sidebarSel = '[data-mc-sidebar]';

      const onStart = (e) => {
        const t = e.touches ? e.touches[0] : e;
        startX = t.clientX;
        startY = t.clientY;
        tracking = true;
      };

      const onEnd = (e) => {
        if (!tracking) return;
        tracking = false;

        const t = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : e;
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;

        if (Math.abs(dy) > MAX_Y) return;          // foi scroll, ignora
        if (Math.abs(dx) < MIN_X) return;          // swipe curto, ignora

        const sidebar = qs(sidebarSel);
        const open = isFiltersOpen();

        // 1) Abrir: swipe left -> right a partir da margem esquerda
        if (!open && startX <= EDGE_PX && dx > 0) {
          openFilters();
          return;
        }

        // 2) Fechar: swipe right -> left quando drawer está aberto
        if (open && dx < 0) {
          // opcional: só fechar se o gesto começou dentro do drawer
          const startedInsideSidebar = sidebar && startX >= (sidebar.getBoundingClientRect().left);
          if (startedInsideSidebar) closeFilters();
        }
      };

      // usa touch events (mais consistente em iOS)
      on(document, 'touchstart', onStart, { passive: true });
      on(document, 'touchend', onEnd, { passive: true });
    };

    bindSwipeGestures();

    };

    // keep open facets
    const getOpenFacetsIndexes = () => {
      const idxs = [];
      qsa('.mc__sidebar .mc__facet').forEach((facet, idx) => {
        if (facet && facet.open) idxs.push(idx);
      });
      return idxs;
    };

    const restoreOpenFacets = (indexes) => {
      const facets = qsa('.mc__sidebar .mc__facet');
      indexes.forEach(i => { if (facets[i]) facets[i].setAttribute('open', 'open'); });
    };

    // mobile swipes
    const initMobileSwipes = (container) => {
      container = container || root;

      const IS_TOUCH_LOCAL =
        (window.matchMedia && matchMedia('(hover: none), (pointer: coarse)').matches) ||
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
        ('ontouchstart' in window);

      if (!IS_TOUCH_LOCAL) return; // ✅ touch only (mobile/tablet/pc touch)

      qsa('[data-mc-swipe]', container).forEach(swipe => {
        const track = swipe.querySelector('[data-mc-swipe-track]');
        const dotsWrap = swipe.querySelector('[data-mc-dots]');
        const tapLink = swipe.querySelector('[data-mc-tap]');
        if (!track || !tapLink) return;

        const href = tapLink.getAttribute('href');
        if (!href) return;

        // ✅ No touch não queremos overlay link a bloquear swipe
        const isTouch = window.matchMedia && matchMedia('(hover: none), (pointer: coarse)').matches;
        if (isTouch) tapLink.style.pointerEvents = 'none';

        // Dots (se existirem)
        if (dotsWrap) {
          const dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.mc__dot'));
          const setActive = (i) => {
            if (!dots.length) return;
            i = Math.max(0, Math.min(dots.length - 1, i));
            dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
          };
          const calcIndex = () => {
            const w = track.clientWidth || 1;
            return Math.floor((track.scrollLeft + (w * 0.5)) / w);
          };
          setActive(calcIndex());
          let raf = 0;
          track.addEventListener('scroll', () => {
            if (raf) cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => setActive(calcIndex()));
          }, { passive:true });
        }

        // ✅ Tap vs Swipe gate
        let startX = 0, startY = 0, moved = false;
        const MOVE_PX = 10; // limiar para considerar swipe

        const onStart = (e) => {
          const p = e.touches ? e.touches[0] : e;
          startX = p.clientX;
          startY = p.clientY;
          moved = false;
        };

        const onMove = (e) => {
          const p = e.touches ? e.touches[0] : e;
          const dx = Math.abs(p.clientX - startX);
          const dy = Math.abs(p.clientY - startY);
          if (dx > MOVE_PX || dy > MOVE_PX) moved = true;
        };

        const onEnd = () => {
          // se houve swipe/movimento, não abre
          if (moved) return;
          window.location.href = href;
        };

        // Touch (mobile/tablet)
        track.addEventListener('touchstart', onStart, { passive: true });
        track.addEventListener('touchmove', onMove, { passive: true });
        track.addEventListener('touchend', onEnd, { passive: true });

        // Pointer (tablet/desktop touch + compat)
        track.addEventListener('pointerdown', onStart, { passive: true });
        track.addEventListener('pointermove', onMove, { passive: true });
        track.addEventListener('pointerup', onEnd, { passive: true });
      });

    };

    // sliders
    const initSliders = (container) => {
      qsa('[data-price-slider]', container).forEach(wrapper => {
        const input    = wrapper.querySelector('[data-slider-input]');
        const valueEl  = wrapper.querySelector('[data-slider-value]');   // dentro do bubble
        const rangeMaxEl = wrapper.querySelector('[data-slider-range-max]'); // footer estático
        const bubbleEl = wrapper.querySelector('[data-slider-bubble]');
        if (!input || !valueEl) return;

        const currency  = (wrapper.getAttribute('data-currency') || '').trim();
        const minParam  = wrapper.getAttribute('data-min-param');
        const maxParam  = wrapper.getAttribute('data-max-param');
        const minDefault = parseInt(wrapper.getAttribute('data-min-default') || '0', 10);

        const formatCents = (cents) => {
          const n = cents / 100;
          const txt = n.toFixed(2).replace(/\.00$/, '');
          return currency ? (currency + txt) : txt;
        };

        // atualiza gradiente de preenchimento do track
        const updateFill = (v) => {
          const min = parseInt(input.min || '0', 10);
          const max = parseInt(input.max || '100', 10);
          const pct = max > min ? ((v - min) / (max - min)) * 100 : 100;
          input.style.setProperty('--mc-slider-pct', pct.toFixed(1) + '%');
          return pct;
        };

        // posiciona o bubble centrado sobre o thumb, corrigindo o offset lateral do thumb
        const updateBubble = (pct) => {
          if (!bubbleEl) return;
          const thumbSz = parseFloat(getComputedStyle(input).getPropertyValue('--mc-slider-thumb-sz')) || 22;
          const trackW  = input.offsetWidth || 200;
          // o thumb percorre (trackW - thumbSz), não trackW completo
          const corrected = trackW > 0
            ? (thumbSz / 2 + (pct / 100) * (trackW - thumbSz)) / trackW * 100
            : pct;
          bubbleEl.style.setProperty('--mc-bubble-x', corrected.toFixed(2) + '%');
        };

        // anima o bubble
        let pulseTimer;
        const pulseBubble = () => {
          if (!bubbleEl) return;
          bubbleEl.classList.remove('is-changing');
          void bubbleEl.offsetWidth;
          bubbleEl.classList.add('is-changing');
          clearTimeout(pulseTimer);
          pulseTimer = setTimeout(() => bubbleEl.classList.remove('is-changing'), 260);
        };

        // estado inicial
        const initVal = parseInt(input.value || '0', 10);
        const initPct = updateFill(initVal);
        updateBubble(initPct);

        on(input, 'input', () => {
          const v = parseInt(input.value || '0', 10);
          const formatted = formatCents(v);
          valueEl.textContent = formatted;
          if (rangeMaxEl) rangeMaxEl.textContent = formatted;
          const pct = updateFill(v);
          updateBubble(pct);
          pulseBubble();
        });

        on(input, 'change', () => {
          const v = parseInt(input.value || '0', 10);
          const url = new URL(window.location.href);
          const toMoneyParam = (cents) => (cents / 100).toFixed(2).replace(/\.00$/, '');
          if (maxParam) url.searchParams.set(maxParam, toMoneyParam(v));
          if (minParam && !url.searchParams.get(minParam)) url.searchParams.set(minParam, toMoneyParam(minDefault));
          url.searchParams.delete('page');
          fetchAndRender(url.toString(), { push:true });
        });

        // recalcula posição do bubble ao resize (sidebar pode mudar largura)
        on(window, 'resize', () => {
          const v = parseInt(input.value || '0', 10);
          updateBubble(updateFill(v));
        });
      });
    };

    // custom selects
    const closeAllSelects = (container) => {
      qsa('[data-mc-select]', container).forEach(wrap => {
        const btn = wrap.querySelector('[data-mc-select-btn]');
        const menu = wrap.querySelector('[data-mc-select-menu]');
        if (!btn || !menu) return;
        menu.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      });
    };

    const initCustomSelects = (container) => {
      qsa('[data-mc-select]', container).forEach(wrap => {
        if (wrap.getAttribute('data-mc-select-init') === '1') return;
        wrap.setAttribute('data-mc-select-init', '1');

        const select = wrap.querySelector('select');
        const btn = wrap.querySelector('[data-mc-select-btn]');
        const text = wrap.querySelector('[data-mc-select-text]');
        const menu = wrap.querySelector('[data-mc-select-menu]');
        const list = wrap.querySelector('[data-mc-select-list]');
        if (!select || !btn || !text || !menu || !list) return;

        wrap.classList.add('is-enhanced');

        const syncLabel = () => {
          const opt = select.options[select.selectedIndex];
          text.textContent = opt ? opt.textContent : '';
        };

        const build = () => {
          list.innerHTML = '';
          Array.prototype.slice.call(select.options).forEach(opt => {
            const li = document.createElement('li');
            li.className = 'mc__select-opt' + (opt.selected ? ' is-active' : '');
            li.setAttribute('role', 'option');
            li.innerHTML = '<span class="lbl"></span><span class="tick" aria-hidden="true"></span>';
            li.querySelector('.lbl').textContent = opt.textContent;

            li.addEventListener('click', (e) => {
              e.preventDefault();
              select.value = opt.value;
              select.dispatchEvent(new Event('change', { bubbles:true }));
              close();
            });

            list.appendChild(li);
          });
        };

        const open = () => {
          closeAllSelects(container);
          build();
          syncLabel();
          menu.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        };

        const close = () => {
          menu.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        };

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (menu.hidden) open();
          else close();
        });

        document.addEventListener('click', (e) => {
          if (!wrap.contains(e.target)) close();
        }, true);

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') close();
        }, true);

        window.addEventListener('scroll', close, { passive:true });
        window.addEventListener('resize', close, { passive:true });

        syncLabel();
        select.addEventListener('change', syncLabel);
      });
    };

    // cart helpers
    const getCart = async () => {
      const cartRes = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!cartRes.ok) throw new Error('Failed to fetch cart');
      return await cartRes.json();
    };

    const updateHeaderCartBubble = (cart) => {
      const a = document.getElementById('cart-icon-bubble');
      const itemCount = Number(cart && cart.item_count ? cart.item_count : 0);
      if (!a) return;

      let bubble = a.querySelector('.cart-count-bubble');

      if (itemCount > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          a.appendChild(bubble);
        }
        const visible = bubble.querySelector('span[aria-hidden="true"]');
        if (visible) visible.textContent = itemCount < 100 ? String(itemCount) : '';
        const sr = bubble.querySelector('span.visually-hidden');
        if (sr) sr.textContent = 'Carrinho com ' + String(itemCount) + ' itens';
      } else {
        if (bubble) bubble.remove();
      }
    };

    const updateSelectorBadge = (cart) => {
      try{
        const sel = root.getAttribute('data-cart-count-selector') || '';
        if (!sel) return;
        const el = document.querySelector(sel);
        if (!el) return;
        el.textContent = String(cart.item_count || 0);
        el.setAttribute('aria-label', 'Carrinho com ' + String(cart.item_count || 0) + ' itens');
      }catch(e){}
    };

    const dispatchCartEvents = (cart) => {
      try{
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:change',  { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:added',   { detail: cart }));
      }catch(e){}
    };

    const addToCart = async (variantId, qty) => {
      if (!variantId) return;
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: Number(qty || 1) })
      });
      if (!res.ok) throw new Error(await res.text() || 'Add to cart failed');
      await res.json();

      const cart = await getCart();
      updateHeaderCartBubble(cart);
      updateSelectorBadge(cart);
      dispatchCartEvents(cart);
      return cart;
    };

    // ✅ async fetchAndRender (no illegal await)
    const fetchAndRender = async (href, opts={}) => {
      if (!href) return;

      // Detectar se o drawer estava aberto ANTES de qualquer cleanup
      const _portalSidebar = document.querySelector('.mc__portal-sidebar');
      const _rootSidebar = qs('[data-mc-sidebar]');
      const drawerWasOpen = (
        (_portalSidebar && _portalSidebar.classList.contains('is-open')) ||
        (_rootSidebar && _rootSidebar.classList.contains('is-open'))
      );
      const isMobile = typeof matchMedia !== 'undefined' && matchMedia('(max-width: 1199px)').matches;

      // Mobile surgical mode: drawer stays open, only grid + facets refreshed behind it
      const mobileSurgical = drawerWasOpen && isMobile;

      // reset baseline para a altura actual antes de bloquear
      baselineHeight = 0;
      try{
        const store = (window.__MerchCollection = window.__MerchCollection || {});
        if (store[sectionId]) store[sectionId].baselineHeight = 0;
      }catch(e){}

      if (mobileSurgical) {
        // Mark filter-reload BEFORE setBusy so sidebar/mobilebar stay interactive during load
        root.classList.add('is-filter-reload');
      }

      setBusy('load');

      if (!mobileSurgical) {
        // Limpar portal SEMPRE antes de substituir o DOM:
        // portalUnmount() devolve a sidebar ao root para que replaceWith() a destrua correctamente.
        try { if (portal.active) portalUnmount(); } catch(e) {}
        try { lockBody(false); } catch(e) {}
        // Remover quaisquer elementos portal órfãos que possam ter ficado no body
        try {
          document.querySelectorAll('.mc__portal-sidebar, .mc__portal-overlay').forEach(el => el.remove());
        } catch(e) {}
      }

      closeAllSelects(root);

      // Capture open facet indexes from wherever the sidebar currently is
      const activeSidebar = _portalSidebar || _rootSidebar;
      const openIndexes = (() => {
        const container = activeSidebar || root;
        return Array.from(container.querySelectorAll('.mc__facet'))
          .reduce((acc, f, i) => { if (f.open) acc.push(i); return acc; }, []);
      })();

      const pageUrl = new URL(href, window.location.origin);
      const sectionUrl = new URL(href, window.location.origin);
      sectionUrl.searchParams.set('section_id', sectionId);

      let html;
      try{
        const res = await fetch(sectionUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        html = await res.text();
      }catch(e){
        window.location.href = href;
        return;
      }

      const temp = document.createElement('div');
      temp.innerHTML = html;

      let newSection =
        (rootId ? temp.querySelector('#' + CSS.escape(rootId)) : null) ||
        temp.querySelector('[data-section-id="' + sectionId + '"]');

      if (!newSection){
        window.location.href = href;
        return;
      }

      newSection.querySelectorAll('script').forEach(s => s.remove());

      if (mobileSurgical) {
        // ── Surgical update: drawer stays open, only refresh grid + facets behind it ──

        // 1. Replace product grid content area (includes toolbar with active chips)
        const newContent = newSection.querySelector('.mc__content');
        const oldContent = qs('.mc__content');
        if (newContent && oldContent) oldContent.replaceWith(newContent);

        // 2. Update facets inside the open sidebar (counts + active states)
        if (activeSidebar) {
          const newFacets = newSection.querySelector('.mc__facets');
          const oldFacets = activeSidebar.querySelector('.mc__facets');
          if (newFacets && oldFacets) oldFacets.replaceWith(newFacets);

          // 3. Update drawer footer (Limpar tudo link appears/disappears)
          const newFooter = newSection.querySelector('.mc__drawer-footer');
          const oldFooter = activeSidebar.querySelector('.mc__drawer-footer');
          if (newFooter && oldFooter) oldFooter.replaceWith(newFooter);

          // 4. Re-init sliders on updated facets (direct event listeners, not delegated)
          initSliders(activeSidebar);

          // 5. Restore open accordion facets in the sidebar
          const updatedFacets = Array.from(activeSidebar.querySelectorAll('.mc__facet'));
          openIndexes.forEach(i => { if (updatedFacets[i]) updatedFacets[i].setAttribute('open', 'open'); });
        }

        // 6. Update active filter count badge on the filter button
        try{
          const countEl = root.querySelector('[data-mc-active-count]');
          if (countEl) {
            const n = root.querySelectorAll('.mc__chip').length;
            countEl.textContent = n || '';
            countEl.style.display = n ? '' : 'none';
          }
        }catch(e){}

        // 7. Reveal: remove loading state, keep is-filter-reload until next frame
        root.classList.remove('is-booting', 'is-loading');
        void root.offsetHeight;
        requestAnimationFrame(() => {
          try {
            root.classList.add('is-ready');
            root.classList.remove('is-filter-reload');
          }catch(e){}
        });

      } else {
        // ── Full section replace (desktop or drawer was closed) ──
        newSection.classList.add('is-loading');

        root.replaceWith(newSection);
        root = newSection;

        try{ root.classList.remove('is-ready'); }catch(e){}
        void root.offsetHeight;

        // Restore open facets via root-scoped lookup (sidebar is inside root now)
        const facetEls = qsa('.mc__sidebar .mc__facet');
        openIndexes.forEach(i => { if (facetEls[i]) facetEls[i].setAttribute('open', 'open'); });

        try{
          const store = (window.__MerchCollection = window.__MerchCollection || {});
          if (store[sectionId]) store[sectionId].baselineHeight = 0;
        }catch(e){}

        // marca como filter reload: o reveal só anima .mc__content (hero/sidebar ficam visíveis)
        root.classList.add('is-filter-reload');

        // re-init on replaced root
        initMerchCollection(root);
      }

      // Render JM badges + update count/empty state for both surgical and full-replace paths.
      // mcHydrateJudgeMe calls renderBadges AND reads data-number-of-reviews in a RAF
      // to show [data-jm-count] or [data-jm-empty] correctly.
      try{ mcHydrateJudgeMe(root); }catch(e){}

      if (opts.push) history.pushState({ mc_section_id: sectionId }, '', pageUrl.toString());
      else history.replaceState({ mc_section_id: sectionId }, '', pageUrl.toString());
    };

    // handlers
    const handleClick = (e) => {
      const link = e.target.closest('.mc__check, .mc__badge-pill, .mc__chip, .mc__pagination a, .mc__clear');
      if (link && root.contains(link)){
        if (link.classList.contains('mc__check--link')) return;
        e.preventDefault();
        fetchAndRender(link.href, { push:true });
        return;
      }

      const btn = e.target.closest('[data-add-to-cart]');
      if (btn && root.contains(btn)){
        e.preventDefault();
        e.stopPropagation();

        const vid = btn.getAttribute('data-variant-id');
        const qty = btn.getAttribute('data-qty') || '1';

        btn.disabled = true;
        btn.classList.add('is-loading');

        addToCart(vid, qty)
          .catch(() => { window.location.href = '/cart'; })
          .finally(() => {
            btn.disabled = false;
            btn.classList.remove('is-loading');
          });
      }
    };

    const handleChange = (e) => {
      if (e.target.matches('.mc__sort select[name="sort_by"]')){
        const url = new URL(window.location.href);
        const val = e.target.value || '';
        if (val) url.searchParams.set('sort_by', val);
        else url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        e.preventDefault();
        fetchAndRender(url.toString(), { push:true });
      }
    };

    // bind
    on(root, 'click', handleClick);
    on(root, 'change', handleChange);

    // Filter link clicks from portaled sidebar (portaled elements live in body, not inside root,
    // so root's click delegation doesn't reach them — handle at document level)
    on(document, 'click', (e) => {
      const portalSidebar = document.querySelector('.mc__portal-sidebar');
      if (!portalSidebar) return;
      const link = e.target.closest('.mc__check, .mc__chip, .mc__clear');
      if (!link || !portalSidebar.contains(link)) return;
      if (link.classList.contains('mc__check--link')) return;
      e.preventDefault();
      fetchAndRender(link.href, { push: true });
    });

    on(window, 'popstate', () => fetchAndRender(window.location.href, { push:false }));

    // ---- TOUCH MODE FLAG (para CSS: .is-touch) ----
    const IS_TOUCH_LOCAL =
      (window.matchMedia && matchMedia('(hover: none), (pointer: coarse)').matches) ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      ('ontouchstart' in window);

    root.classList.toggle('is-touch', !!IS_TOUCH_LOCAL);

    bindDrawer();
    initSliders(root);
    initMobileSwipes(root);
    initCustomSelects(root);

    setBusy('boot');
    mcHydrateJudgeMe(root);
    revealWhenReady(root);

    store[sectionId] = { cleanup: () => {
      try{ portalUnmount(); }catch(e){}
      offFns.forEach(fn => fn());
    }};

  }

  

  function initAll(){
    document.querySelectorAll('.merch-collection[data-section-id]').forEach(initMerchCollection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target && e.target.querySelector && e.target.querySelector('.merch-collection[data-section-id]');
    if (root) initMerchCollection(root);
  });
})();
